import {
  HttpClient,
  HttpClientRequest,
  HttpClientResponse,
} from "@effect/platform";
import { GRAPH_ENDPOINT, ProdProtocolKeyService } from "@silo/types";
import { Effect, pipe } from "effect";
import { Schema } from "@effect/schema";
import { GraphError } from "./types";
import { Scope } from "effect/Scope";

interface RequestParams<A, I, R> {
  query: string;
  variables?: { [key: string]: unknown };
  schema: Schema.Schema<A, I, R>;
}

export function request<A, I, R>({
  query,
  variables,
  schema,
}: RequestParams<A, I, R>): Effect.Effect<
  A,
  GraphError,
  ProdProtocolKeyService | Exclude<R, Scope>
> {
  return Effect.gen(function* () {
    const protocolKey = yield* ProdProtocolKeyService;

    const endpoint = GRAPH_ENDPOINT[protocolKey];

    const Response = Schema.Struct({
      data: schema,
    });

    const { data } = yield* pipe(
      HttpClientRequest.post(endpoint),
      HttpClientRequest.setHeader("Content-Type", "application/json"),
      HttpClientRequest.jsonBody({
        query,
        variables,
      }),
      Effect.andThen(HttpClient.fetch),
      Effect.andThen(
        HttpClientResponse.schemaBodyJson(Response, { errors: "all" })
      ),
      Effect.scoped
    );

    return data;
  }).pipe(Effect.mapError((cause) => new GraphError({ cause })));
}
